import React from 'react';
import { FiUpload, FiCheckCircle } from "react-icons/fi";

const QuestionPalette = ({ questions, currentQIndex, handlePaletteClick, tabs, activeTab, setActiveTab }) => {
    return (
        <div className="w-full lg:w-[320px] bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col h-fit">
            <div className="bg-[#D7EAFF] px-4 py-3 border-b border-gray-300">
                <h3 className="font-bold text-gray-700">Question Palette</h3>
            </div>

            {/* Tabs */}
            <div className="flex text-[10px] overflow-x-auto no-scrollbar">
                {tabs.map((tab, idx) => (
                    <button
                        key={tab.label}
                        onClick={() => setActiveTab(idx)}
                        className={`flex-1 py-3 px-1 font-bold whitespace-nowrap transition-all
                            ${activeTab === idx ? "border-b-2 border-[#E63946] text-[#E63946]" : "text-[#333333B2] border-[#33333380] border-b-2"}`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="p-4">
                <div className="flex justify-between text-[12px] font-[500] text-[#333333] mb-4">
                    <span>{tabs[activeTab].title}</span>
                    <span>5/25 Answered</span>
                </div>

                {/* Grid */}
                <div className="grid grid-cols-7 md:grid-cols-15 lg:grid-cols-5 md:grid-cols-5 gap-y-2 gap-x-2 md:gap-x-4 mb-6">
                    {questions.map((q, idx) => {
                        const isCurrent = idx === currentQIndex;
                        let statusStyles = "bg-[#F2EAEA] border-2 border-[#33333366] text-[#333333] font-[500]";

                        if (isCurrent) statusStyles = "bg-[#FFCFCF] border-2 border-[#E6394687] text-[#FA0000] font-[500]";
                        else if (q.status === "answered") statusStyles = "bg-white border-[#21C11E] text-gray-700";
                        else if (q.status === "marked") statusStyles = "bg-white border-[#EAB308] text-gray-700";

                        return (
                            <div
                                key={q.id}
                                onClick={() => handlePaletteClick(idx)}
                                className={`aspect-square flex items-center justify-center rounded border text-xs cursor-pointer hover:brightness-95 transition-all ${statusStyles}`}
                            >
                                {q.id}
                            </div>
                        );
                    })}
                </div>

                {/* Legend */}
                <div className="grid grid-cols-2 gap-y-5 text-[13px] font-[500] text-[#333333] mb-6">
                    <div className="flex items-center gap-2"><div className="w-4 h-4 border-2 border-[#21C11E] bg-[#EAEAEA] rounded-sm"></div> Answered</div>
                    <div className="flex items-center gap-2"><div className="w-4 h-4 border-2 border-[#969796] bg-[#EAEAEA] rounded-sm"></div> Not Answered</div>
                    <div className="flex items-center gap-2"><div className="w-4 h-4 border-2 border-[#E9B423] bg-[#EAEAEA] rounded-sm"></div> Marked</div>
                    <div className="flex items-center gap-2"><div className="w-4 h-4 border-2 border-[#E63946] bg-[#EAEAEA] rounded-sm"></div> Current</div>
                </div>

                <div className="space-y-2">
                    <button className="w-full bg-[#21C11E] text-white py-2 rounded font-[500] text-[15px] flex items-center justify-center gap-2">
                        <FiUpload className="text-[20px]" /> Submit Section
                    </button>
                    <button className="w-full bg-[#21C11E] text-white py-2 rounded font-[500] text-[15px] flex items-center justify-center gap-2">
                        <FiCheckCircle className="text-[20px]" /> Submit Test
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuestionPalette;